import React, { Component } from 'react'
import classnames from 'classnames'
import VideoLoop from '../video/VideoLoop'

class HeroVideo extends Component {
  constructor(props) {
    super(props)
    this.state = { complete: false }
  }
  componentDidMount() {
    this.props.onPrepare && this.props.onPrepare(this.props.name)
  }

  componentWillUnmount() {
    if (this.img) {
      this.img.onload = null
      this.img = null
    }
  }
  
  onLoad = () => {
    this.setState({
      complete: true
    }, () => {
      this.props.onLoad && this.props.onLoad(this.props.name)
    })
  }

  render() {
    const { width, height,videoSrc, videoPosterSrc, mediaClassNames  } = this.props 
    const { complete } = this.state
    const imageClassNames = classnames({
      'media-image--complete': complete,
      'media-image--vertical': (height / width > 1),
    }, 'media-image')
  
    return (
      <div className={`${mediaClassNames} ${imageClassNames}`} >
        <VideoLoop 
          active={ this.props.active }
          src={ videoSrc } 
          playsInline
          muted
          poster={ videoPosterSrc }
          onLoadedMetadata={this.onLoad} 
        />
      </div>
    )
  }
}

export default HeroVideo



// WEBPACK FOOTER //
// ./src/components/hero/hero-video.js